const DECORATION_TYPE = {
  1: "DTG",
  2: "Screen Print",
  3: "Embroidery",
  // 4: 'Vinyl',
  //   5: "Other",
  6: "DTF",
  7: "Sublimation",
  8: "DTF Gang Sheet",
  9: "Laser",
  10: "Digital Printing",
  11: "Puff Embroidery",
  20: "Hard Goods",
};

export const HARD_GOODS_DECORATION_METHOD = "20";

// export const PLACEMENT_OPTIONS = {
//   1: "Full Front",
//   2: "Back",
//   3: "Left Chest",
//   4: "Right Chest",
//   5: "Front and Back",
//   8: "All Over Print",
//   9: "Impression",
//   10: "Top",
//   11: "Bottom",
//   12: "Front 2",
//   13: "Back 2",
//   14: "Back 3",
//   15: "Front Left",
//   16: "Front Right",
//   17: "Top Half Front",
//   18: "Top Half Back",
//   19: "Front Left Leg",
//   20: "Front Right Leg",
//   21: "Side Left Leg",
//   22: "Side Right Leg",
//   23: "Nape",
//   24: "Bottom Front",
//   25: "Bottom Back",
//   26: "Collar",
// };

export default DECORATION_TYPE;
